module.exports = __webpack_public_path__ + "img/crew.d6b0cc97.webp";